import { FC } from 'react';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { FormattedMessage } from 'react-intl';

const LinkToManage: FC = () => (
  <Button
    linkSimpleProps={{ href: '/manage' }}
    variant={ButtonVariant.black65}
    pill
    textUppercase
    additionalClassName="flex-grow-1"
  >
    <FormattedMessage defaultMessage="Advertise" />
  </Button>
);

export { LinkToManage };
